import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { Commission, IAPICommission } from 'src/model/commission.model';

@Injectable({
  providedIn: 'root'
})

export class CommissionAdapter {
  adapt(item: any): Commission {
    return new Commission(
      item.id,
      item.loanId,
      item.amount,
      item.assignee,
      item.assignor,
      item.transactionId,
      item.dateCreated,
      item.customerId,
      item.customerName,
      item.principal,
      item.assigned,
      item.paymentAmount,
      item.paid,
      item.customerCode,
      item.companyId,
      item.companyCode,
      item.scheme
    )
  }

  toApiModel(comm: Commission): IAPICommission {
    return {
      amount: comm.Amount,
      loanId: comm.LoanId,
      assignee: comm.Assignee,
      dateCreated: comm.DateCreated
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class CommissionService {
  private api = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private adapter = inject(CommissionAdapter);

  getLoanCommissions(loanId: number): Promise<Commission[]> {
    return new Promise<Commission[]>((resolve, reject) => {
      this.api.get<Commission[]>(this.constructApi.getLoanCommissions(loanId)).pipe(
        map(data => data.map(d => this.adapter.adapt(d)))
      ).subscribe({
        next: response => resolve(response),
        error: err => {
          console.error(err);
          this.api.handleError(err);
          reject(err);
        }
      });
    });
  }

  deleteCommission(id: number, loanId: number) {
    return new Promise((resolve, reject) => {
      this.api.delete(this.constructApi.getDeleteLoanCommission(loanId, id)).subscribe({
        next: response => resolve(true),
        error: err => {
          this.api.handleError(err);
          console.error('Failed to delete commission: ', err);
          reject(err);
        }
      })
    })
  }

  getAllUnpaidCommissionByCompany(companyId?: number): Promise<Map<number, number>> {
    const url = companyId ? this.constructApi.getCompanyUnpaidCommission(companyId) : this.constructApi.getAllUnpaidCommission();
    return new Promise<Map<number, number>>((resolve, reject) => {
      this.api.get<Commission[]>(url).pipe(
        map(data => data.map(d => this.adapter.adapt(d)))
      ).subscribe({
        next: response => {
          const result = response.reduce((result, item) => {
            const v = (result.get(item.CompanyId) ?? 0) + item.Amount - item.Paid;
            result.set(item.CompanyId, v);
            return result;
          }, new Map<number, number>())
          resolve(result);
        },
        error: err => {
          console.error(err);
          this.api.handleError(err);
          reject(err);
        }
      });
    });
  }
}
